module.exports = __webpack_public_path__ + "static/media/arrow_forward-24px.66bdaa19.svg";